import circuit from "../assets/img/circuit.svg";

export const MantineTheme = {
  colorScheme: "dark",
  primaryColor: "violet",
  secondaryColor: "teal",
  fontFamily: "Nunito Sans, sans-serif",
  primaryShade: {
    dark: 5,
    light: 5,
  },
  colors: {
    dark: [
      "#A3B4C8",
      "#647D9D",
      "#48586C",
      "#343E4B",
      "#262C34",
      "#1B1F24",
      "#0F1215",
      "#090A0C",
      "#050607",
      "#030304",
    ], // https://omatsuri.app/color-shades-generator (42,12)
    grape: [
      "#FFD7FC",
      "#FF96F8",
      "#FF5DF4",
      "#FF2CF1",
      "#FF03ED",
      "#DF01CE",
      "#BD00AF",
      "#A00093",
      "#86007C",
      "#710068",
    ], // https://omatsuri.app/color-shades-generator (16,2)
    violet: [
      "#F0ECFC",
      "#D9D0F8",
      "#C3B4F7",
      "#AE97F7",
      "#987AFA",
      "#835DFF",
      "#744BF8",
      "#673CF1",
      "#5B2FE8",
      "#2C2446",
    ], // https://omatsuri.app/color-shades-generator (7, -7)
    blue: [
      "#DAFCFF",
      "#8CF5FF",
      "#48EFFF",
      "#0DEAFF",
      "#00E6FF",
      "#00B6EF",
      "#00B5FE",
      "#009AD8",
      "#0083B7",
      "#006F9C",
    ], // https://omatsuri.app/color-shades-generator (15, 50)
    teal: [
      "#B0FFFF",
      "#67FFFF",
      "#28FFFF",
      "#00FFFF",
      "#00FFFF",
      "#00DEC0",
      "#00ECC6",
      "#00C8A8",
      "#00AA8F",
      "#009179",
    ], // https://omatsuri.app/color-shades-generator (15, 50)
  },
  globalStyles: (theme) => ({
    body: {
      backgroundImage: `url(${circuit}), linear-gradient(180deg, rgba(44,36,70,1) 0%, rgba(30,30,30,1) 100%)`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center bottom",
      minHeight: "100vh",
      overflow: "hidden",
      color: theme.colorScheme === "dark" ? "white" : theme.colors.gray[7],
    },
  }),
  headings: {
    fontFamily: "Nunito Sans, sans-serif",
    fontWeight: 900,
    sizes: {
      h1: {
        fontSize: "40px",
      },
    },
  },
  // spacing: {
  //     xs: '8px',
  //     sm: '16px',
  //     md: '24px',
  //     lg: '32px',
  //     xl: '40px',
  // },
  components: {
    Tooltip: {
      defaultProps: {
        openDelay: 300,
        placement: "center",
        position: "top",
        transition: "pop",
      },
      styles: {
        tooltip: {
          fontSize: "12px",
        },
      },
    },
    Button: {
      defaultProps: (theme) => ({
        color: "grape",
        size: "lg",
        radius: "xl",
      }),
    },
    TextInput: {
      styles: (theme) => ({
        input: {
          border: "none",
          backgroundColor:
            theme.colorScheme === "dark"
              ? theme.colors[theme.primaryColor][9]
              : theme.colors[theme.primaryColor][0],
          color: theme.colorScheme === "dark" ? "white" : theme.colors.dark[6],
          "::placeholder": {
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[2]
                : theme.colors.dark[0],
          },
        },
        rightSection: {
          width: "auto",
          paddingRight: "10px",
        },
      }),
    },
  },
};
